<p>Please provide information regarding professional qualifications and/or trade memberships beginning with the most
    recent.</p>

<p>Professional Qualifications is classed as industry specific qualifications or vocational training (e.g.
    accountancy, financial analysis, IT etc.).
</p>

<p>We recommend you use your CV to complete this section as Bank of America will require all necessary types of
    professional qualifications to be verified.
</p>

<p> Not disclosing information could lead to new requests for information as well as delays to your screening closure.
</p>

<mat-divider aria-hidden="true"></mat-divider>

<mat-dialog-actions align="end">
    <button mat-raised-button class="close-button" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>